import { render } from "./TextareaTypeComponent.vue?vue&type=template&id=73e68d2c&scoped=true"
import script from "./TextareaTypeComponent.vue?vue&type=script&lang=js"
export * from "./TextareaTypeComponent.vue?vue&type=script&lang=js"

import "./TextareaTypeComponent.vue?vue&type=style&index=0&id=73e68d2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e68d2c"]])

export default __exports__